import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-web-session",
  "use": "icon-web-session-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-web-session\">\n<g id=\"icon-web-session_Frame 33924\">\n<circle id=\"icon-web-session_Ellipse 429\" cx=\"8\" cy=\"8\" r=\"7.5\" fill=\"#D1DDFF\" stroke=\"#2F5FF2\" />\n<circle id=\"icon-web-session_Ellipse 430\" cx=\"8\" cy=\"8\" r=\"4\" fill=\"#2F5FF2\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol